import React from 'react';
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { SystemTranslationKeys } from '@common/entities';

import { useSystemTranslation } from 'hooks';

import termsAndConditionsTerms from '../../../render-page/pages/payment/termsAndConditionsTerms';

/** Set to true when Terms & Conditions footer links should be shown again. */
export const SHOW_TERMS_AND_CONDITIONS_FOOTER_LINK = false;

interface Props {
  hidden?: boolean;
}

function FooterLinks({ hidden = false }: Props) {
  const { tSystem } = useSystemTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const termsLabel = tSystem(SystemTranslationKeys.footer.termsAndConditions);

  return (
    <>
      <Flex
        fontSize="12px"
        color="blue.500"
        gap={4}
        bottom={0}
        display={hidden ? 'none' : undefined}
      >
        <span key="terms">
          <Button variant="link" onClick={onOpen} fontSize="12px">
            {termsLabel}
          </Button>
        </span>
      </Flex>
      <Modal onClose={onClose} size="5xl" isOpen={isOpen} scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent backgroundColor="white" overflow="hidden">
          <ModalHeader
            backgroundColor="teal.600"
            color="white"
            justifyContent="center"
            alignItems="center"
          >
            <Text size="lg">{tSystem(SystemTranslationKeys.footer.termsAndConditionsTitle)}</Text>
          </ModalHeader>
          <ModalCloseButton position="absolute" right="4" top="4" color="white.base" />

          <ModalBody height="55vh" overflowY="auto" fontSize={{ base: '10px', md: '14px' }}>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: termsAndConditionsTerms.terms,
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default FooterLinks;
